import {format, parseISO, subMonths} from 'date-fns';
import {useState, useEffect} from 'react';
import {ptBR} from 'date-fns/locale';
import {GetReferralsParams} from 'domain/usecases/private/my-referrals-flow/get-referrals';

export const useDateFilter = (
	firstDate?: string,
	secondDate?: string,
	handleFilter?: (filters: Partial<GetReferralsParams>) => void,
) => {
	const [openDatePickerState, setOpenDatePickerState] = useState(false);
	const defaultInterval = {
		startDate: format(subMonths(new Date(), 3), 'yyyy-MM-dd'),
		finalDate: format(new Date(), 'yyyy-MM-dd'),
	};

	const currentInterval = {
		startDate: firstDate || defaultInterval.startDate,
		finalDate: secondDate || defaultInterval.finalDate,
	};

	const [dateInterval, setDateInterval] = useState(currentInterval);

	useEffect(() => {
		setDateInterval({
			startDate: firstDate || defaultInterval.startDate,
			finalDate: secondDate || defaultInterval.finalDate,
		});
	}, [firstDate, secondDate, defaultInterval.startDate, defaultInterval.finalDate]);

	const formatted = `${format(parseISO(dateInterval.startDate), 'dd/MM/yy', {
		locale: ptBR,
	})} a ${format(parseISO(dateInterval.finalDate), 'dd/MM/yy', {locale: ptBR})}`;
	const handleResetDatePicker = () => {
		setOpenDatePickerState(false);
		setDateInterval(defaultInterval);
	};

	const handleClearDates = () => {
		handleResetDatePicker();
		if (handleFilter) {
			handleFilter({
				dtInicio: defaultInterval.startDate,
				dtFim: defaultInterval.finalDate,
			});
		}
	};

	return {
		defaultInterval,
		openDatePickerState,
		setOpenDatePickerState,
		setDateInterval,
		formatted,
		handleResetDatePicker,
		handleClearDates,
	};
};
